import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { CertificateSettingsFragmentDoc } from './CertificateSettings';
export type IssuedCertificateContent_ArticleContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_BaseResourceSchema_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_CheckinType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_CourseContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_ExerciseType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_ExternalContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_ExternalEventContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_HomeworkType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_KnowledgeAssetContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_LiveEventContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_MicroLearningContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_OfflineEventContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_PathContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_QuizContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_RecurringExternalEventContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_RecurringLiveEventContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_RecurringOfflineEventContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_ScormContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_SurveyContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContent_TaskContentType_Fragment = { id: string, type: Types.ResourceTypeEnum, certificateSettings?: { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null } | null };

export type IssuedCertificateContentFragment = IssuedCertificateContent_ArticleContentType_Fragment | IssuedCertificateContent_BaseResourceSchema_Fragment | IssuedCertificateContent_CheckinType_Fragment | IssuedCertificateContent_CourseContentType_Fragment | IssuedCertificateContent_ExerciseType_Fragment | IssuedCertificateContent_ExternalContentType_Fragment | IssuedCertificateContent_ExternalEventContentType_Fragment | IssuedCertificateContent_HomeworkType_Fragment | IssuedCertificateContent_KnowledgeAssetContentType_Fragment | IssuedCertificateContent_LiveEventContentType_Fragment | IssuedCertificateContent_MicroLearningContentType_Fragment | IssuedCertificateContent_OfflineEventContentType_Fragment | IssuedCertificateContent_PathContentType_Fragment | IssuedCertificateContent_QuizContentType_Fragment | IssuedCertificateContent_RecurringExternalEventContentType_Fragment | IssuedCertificateContent_RecurringLiveEventContentType_Fragment | IssuedCertificateContent_RecurringOfflineEventContentType_Fragment | IssuedCertificateContent_ScormContentType_Fragment | IssuedCertificateContent_SurveyContentType_Fragment | IssuedCertificateContent_TaskContentType_Fragment;


export type IssuedCertificateContentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const IssuedCertificateContentFragmentDoc = /*#__PURE__*/ gql`
    fragment IssuedCertificateContent on ContentEntity {
  ... on PathContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on TaskContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on CourseContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on CheckinType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on ExerciseType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on QuizContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on ExternalContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on ArticleContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on HomeworkType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on ScormContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on SurveyContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on LiveEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on ExternalEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on OfflineEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on BaseResourceSchema {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on ExternalEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on OfflineEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on LiveEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on RecurringExternalEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on RecurringOfflineEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on RecurringLiveEventContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on KnowledgeAssetContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
  ... on MicroLearningContentType {
    id
    type
    certificateSettings {
      ...CertificateSettings
    }
  }
}
    `;